"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-arrow-left-16><path d="M14 7H4.41l4.3-4.29a1.004 1.004 0 0 0-1.42-1.42l-6 6a1 1 0 0 0 0 1.41l6 6a1 1 0 0 0 1.41-1.41L4.41 9H14a1 1 0 1 0 0-2Z"></path></symbol>';
}
